import * as Animated from './Animated';

export * from './reanimated2';
export default Animated;
